import { type AsyncZippable, zip } from 'fflate'
import { EXPORT_SIZES } from '../constants'
import type { IconConfig } from '../types'
import { IconBuilder } from './IconBuilder'

const STORE_ONLY = { level: 0 } as const

const safeFileName = (name: string): string => {
  const sanitized = name.replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/^-+|-+$/g, '')

  return sanitized.length > 0 ? sanitized : 'icon'
}

function triggerDownload(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')

  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  setTimeout(() => URL.revokeObjectURL(url), 0)
}

export async function downloadSVG(config: IconConfig) {
  const svg = await new IconBuilder(config).toSVG()
  const blob = new Blob([svg], { type: 'image/svg+xml' })

  triggerDownload(blob, `${safeFileName(config.appName)}.svg`)
}

export async function downloadZip(config: IconConfig) {
  const builder = new IconBuilder(config)
  const fileName = safeFileName(config.appName)

  const [pngBytes, svgString] = await Promise.all([
    Promise.all(EXPORT_SIZES.map(async (size) => new Uint8Array(await (await builder.toPNG(size)).arrayBuffer()))),
    builder.toSVG(),
  ])

  const files: AsyncZippable = {}

  EXPORT_SIZES.forEach((size, index) => {
    files[`icons/${size}x${size}/${fileName}.png`] = [pngBytes[index]!, STORE_ONLY]
  })
  files['icon.svg'] = [new TextEncoder().encode(svgString), STORE_ONLY]

  const zipBytes = await new Promise<Uint8Array>((resolve, reject) => {
    zip(files, (error, data) => (error ? reject(error) : resolve(data)))
  })

  triggerDownload(new Blob([zipBytes as BlobPart], { type: 'application/zip' }), `${fileName}-icons.zip`)
}
